import { marqueeWords } from '@/mocks/site';

export default function Marquee() {
  const items = [...marqueeWords, ...marqueeWords];

  return (
    <section className="marquee-wrap relative overflow-hidden border-y border-primary-600/40 bg-primary-500 py-4">
      <div className="pointer-events-none absolute inset-0 hatch-lines-light opacity-40" />
      <div className="marquee-track items-center">
        {items.map((word, index) => (
          <span key={`${word}-${index}`} className="flex items-center">
            <span className="whitespace-nowrap px-6 font-heading text-lg font-medium uppercase tracking-[0.18em] text-background-50 md:text-xl">
              {word}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-accent-500" />
          </span>
        ))}
      </div>
    </section>
  );
}